import React, {useEffect, useMemo, useState} from 'react';
import {SiDedge} from "react-icons/si";
import SideBar from "./SideBar";
import plugins from "../css/plugins.css"
import {useDispatch, useSelector} from "react-redux";
import ProductCard from "./ProductCard";
import {fetchProductsPaginate} from "../actions/product";
import {useLocation, useSearchParams} from "react-router-dom";
import {
    CATEGORY_BLOCK_HOUSE,
    CATEGORY_EDGED_BOARD, CATEGORY_EVRO_VAGONKA, CATEGORY_FLOOR_BOARD, CATEGORY_IMITATION_TIMBER,
    CATEGORY_PLANED_BLOCK,
    CATEGORY_PLANED_BOARD, CATEGORY_SHTIL
} from "../utils/consts";
import countPageReducer from "../reducers/countPageReducer";

const ShopArea = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const isModalOpen = useSelector(state => state.modal.show);
    const productsFetch = useSelector(state => state.product.products) || [];
    const totalPage = useSelector(state => state.countPage.countPage);
    const total = useSelector(state => state.countPage.total);
    const [searchParams, setSearchParams] = useSearchParams();
    const currentPage = Number(searchParams.get("page")) || 1;
    const [sort, setSort] = useState({field: 'id', type: 'ASC'})
    const totalOnPage = useMemo(() => productsFetch.length, [productsFetch]);

    const pages = Array.from({length: totalPage}, (_, i) => i + 1);

    useEffect(() => {
        const category = (() => {
            switch (location.pathname) {
                case CATEGORY_PLANED_BOARD:
                    return "1";
                case CATEGORY_PLANED_BLOCK:
                    return "2";
                case CATEGORY_EDGED_BOARD:
                    return "3";
                case CATEGORY_BLOCK_HOUSE:
                    return "4";
                case CATEGORY_IMITATION_TIMBER:
                    return "5";
                case CATEGORY_SHTIL:
                    return "6";
                case CATEGORY_FLOOR_BOARD:
                    return "7";
                case CATEGORY_EVRO_VAGONKA:
                    return "8";
                default:
                    return null;
            }
        })();

        dispatch(fetchProductsPaginate(category, currentPage, sort.field, sort.type))

        isModalOpen ? document.body.classList.add("modal-open") : document.body.classList.remove("modal-open");
    }, [location.pathname, dispatch, isModalOpen, currentPage, searchParams, sort]);

    const changePage = (newPage) => {
        setSearchParams({ page: newPage }); // Меняем URL
    };

    return (
        <div className="shop_area shop_reverse mt-100 mb-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-12">
                        <SideBar/>
                    </div>
                    <div className="col-lg-9 col-md-12">
                        <div className="shop_toolbar_wrapper">
                            <div className="shop_toolbar_btn">

                                <button data-role="grid_3" type="button" className="active btn-grid-3"
                                        data-toggle="tooltip"
                                        title="3"></button>

                                <button data-role="grid_4" type="button" className=" btn-grid-4" data-toggle="tooltip"
                                        title="4"></button>

                                <button data-role="grid_list" type="button" className="btn-list" data-toggle="tooltip"
                                        title="List"></button>
                            </div>
                            <div className="select-wrapper">
                                    <select onChange={(e) => {
                                        e.target.value === '1' ? setSort({field: 'price', type: 'ASC'}) : setSort({field: 'price', type: 'DESC'});
                                    }}>
                                        <option defaultValue value="1">Цена по возрастанию</option>
                                        <option value="2">Цена по убыванию</option>
                                    </select>
                            </div>
                            <div className="page_amount">
                                <p>Показано {(currentPage - 1) * 12 + 1}–{((currentPage - 1) * 12 + 1) + totalOnPage - 1} из {total} результатов</p>
                            </div>
                        </div>
                        <div className="row shop_wrapper">
                            {((productsFetch.length === 0 && 'Товары по заданным фильтрам отсутствуют' ) || productsFetch.map((product, index) => (
                                <ProductCard key={index} product={product}/>
                        )))}

                        </div>
                        <div className="shop_toolbar t_bottom">
                            <div className="pagination">
                                <ul>
                                    {pages.map((page, index) => (
                                        <li key={index} className={`${page === currentPage && 'current'}`}><a href="#" onClick={(e) => {
                                            e.preventDefault();
                                            changePage(page);
                                        }}>{page}</a></li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShopArea;